type ModifyListenersParams = {
	element: HTMLElement | null;
	operationName: 'add' | 'remove';
	eventMap: Record<string, EventListener>;
};

export function modifyListeners(params: ModifyListenersParams) {
	const { element, operationName, eventMap } = params;
	const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';

	if (element) {
		Object.keys(eventMap).forEach((eventName) =>
			element[functionName](eventName, eventMap[eventName]),
		);
	}
}
